import React, { useEffect, useState } from 'react';
import { getCpanelAssetUrl, getCentralUserInitials } from '../../helpers/cpanelAuth';

const CentralUserAvatar = ({ user, displayName, size = 'sm', className = '' }) => {
  const pictureUrl = getCpanelAssetUrl(user?.picture);
  const initials = getCentralUserInitials(user);
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [pictureUrl]);

  const showImage = pictureUrl && !imageFailed;
  const sizeClass = size === 'lg' ? 'central-user-avatar--lg' : size === 'xl' ? 'central-user-avatar--xl' : 'central-user-avatar--sm';

  return (
    <div className={`central-user-avatar ${sizeClass} ${className}`.trim()}>
      {showImage ? (
        <img
          src={pictureUrl}
          alt={displayName}
          onError={() => setImageFailed(true)}
        />
      ) : (
        <span className="central-user-avatar__initials">{initials}</span>
      )}
    </div>
  );
};

export default CentralUserAvatar;
